(() => {
  angular.module('gm.common.common', [
    'gm.common.constants',
    'gm.common.controllers',
    'gm.common.decorators',
    'gm.common.directives',
    'gm.common.filters',
    'gm.common.providers',
    'gm.common.services',
  ]);
})();
